import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmptyStateAnalytics = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 420,
	height: 416,
	viewBox: "0 0 420 416",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_22630_1090)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M208.108 416.205C323.042 416.205 416.215 323.032 416.215 208.098C416.215 93.1638 323.042 -0.00878906 208.108 -0.00878906C93.1736 -0.00878906 0.000976562 93.1638 0.000976562 208.098C0.000976562 323.032 93.1736 416.205 208.108 416.205Z",
				fill: "#EBF3FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M317.026 85.5791H116.087C110.268 85.5791 105.546 90.3011 105.546 96.1194V320.711H327.575V96.1194C327.575 90.3011 322.853 85.5791 317.035 85.5791H317.026Z",
				fill: "#9EC5FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M141.146 147.253H169.141C171.241 147.253 172.944 148.956 172.944 151.056V320.712H137.352V151.056C137.352 148.956 139.055 147.253 141.154 147.253H141.146Z",
				fill: "#6BA6FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M204.101 223.471H232.096C234.196 223.471 235.899 225.174 235.899 227.274V320.719H200.307V227.274C200.307 225.174 202.01 223.471 204.11 223.471H204.101Z",
				fill: "#6BA6FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M267.058 180.382H295.053C297.153 180.382 298.856 182.085 298.856 184.185V320.719H263.264V184.185C263.264 182.085 264.967 180.382 267.067 180.382H267.058Z",
				fill: "#6BA6FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M332.888 351.319H73.9351V96.5739C73.9351 94.9802 75.2252 93.6816 76.8273 93.6816C78.4294 93.6816 79.7196 94.9718 79.7196 96.5739V345.543H332.888C334.482 345.543 335.781 346.833 335.781 348.436C335.781 350.038 334.49 351.328 332.888 351.328V351.319Z",
				fill: "#6BA6FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M390.651 238.247C382.801 227.479 370.102 220.488 355.759 220.488C331.921 220.488 312.603 239.815 312.603 263.644C312.603 274.53 316.633 284.48 323.295 292.069C331.204 301.1 342.815 306.8 355.767 306.8C377.092 306.8 394.8 291.336 398.299 271.006C398.713 268.611 398.932 266.149 398.932 263.644C398.932 254.15 395.862 245.372 390.668 238.247H390.651Z",
				fill: "#DCEBFE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M350.165 218V263.644L317.692 289.589C311.039 281.992 307 272.05 307 261.164C307 237.327 326.327 218.008 350.156 218.008L350.165 218Z",
				fill: "#9AEDE6"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M385.055 235.758C377.205 224.99 364.506 218 350.163 218V263.644L392.695 268.526C393.108 266.131 393.327 263.669 393.327 261.164C393.327 251.67 390.258 242.892 385.064 235.767L385.055 235.758Z",
				fill: "#FFCAC5"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M350.166 263.645L317.694 289.59C325.603 298.621 337.214 304.322 350.166 304.322C371.491 304.322 389.199 288.857 392.698 268.527L350.166 263.645Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M155.145 363.707C163.286 363.707 169.885 357.107 169.885 348.967C169.885 340.827 163.286 334.228 155.145 334.228C147.005 334.228 140.406 340.827 140.406 348.967C140.406 357.107 147.005 363.707 155.145 363.707Z",
				fill: "#9EC5FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M108.026 118.945H39.3963C34.9303 118.945 31.3098 122.566 31.3098 127.032V185.619C31.3098 190.085 34.9303 193.705 39.3963 193.705H108.026C112.492 193.705 116.113 190.085 116.113 185.619V127.032C116.113 122.566 112.492 118.945 108.026 118.945Z",
				fill: "#DCEBFE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M103.97 115.244H35.1044C30.7036 115.244 27.136 118.812 27.136 123.213V182.036C27.136 186.437 30.7036 190.004 35.1044 190.004H103.97C108.371 190.004 111.939 186.437 111.939 182.036V123.213C111.939 118.812 108.371 115.244 103.97 115.244Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M85.4445 177.914C85.4445 171.594 80.3156 166.465 73.9951 166.465C80.3156 166.465 85.4445 161.336 85.4445 155.016C85.4445 161.336 90.5734 166.465 96.8938 166.465C90.5734 166.465 85.4445 171.594 85.4445 177.914Z",
				fill: "#9EC5FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M85.4443 178.898C84.8951 178.898 84.4496 178.453 84.4496 177.904C84.4496 172.132 79.7559 167.439 73.9949 167.439C73.4458 167.439 73.0002 166.993 73.0002 166.444C73.0002 165.895 73.4458 165.449 73.9949 165.449C79.7662 165.449 84.4496 160.756 84.4496 154.995C84.4496 154.446 84.8951 154 85.4443 154C85.9934 154 86.439 154.446 86.439 154.995C86.439 160.766 91.1327 165.449 96.8936 165.449C97.4428 165.449 97.8883 165.895 97.8883 166.444C97.8883 166.993 97.4428 167.439 96.8936 167.439C91.1223 167.439 86.439 172.132 86.439 177.904C86.439 178.453 85.9934 178.898 85.4443 178.898ZM78.8544 166.454C81.8074 167.719 84.1802 170.091 85.4443 173.044C86.7084 170.091 89.0811 167.719 92.0341 166.454C89.0811 165.19 86.7084 162.828 85.4443 159.865C84.1802 162.818 81.8074 165.19 78.8544 166.454Z",
				fill: "#9EC5FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M61.2882 162.125C61.2882 152.831 53.7451 145.287 44.4509 145.287C53.7451 145.287 61.2882 137.744 61.2882 128.45C61.2882 137.744 68.8313 145.287 78.1255 145.287C68.8313 145.287 61.2882 152.831 61.2882 162.125Z",
				fill: "#FFE380"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M61.2881 163.576C60.4799 163.576 59.8375 162.923 59.8375 162.125C59.8375 153.639 52.9368 146.738 44.4508 146.738C43.6427 146.738 43.0002 146.086 43.0002 145.288C43.0002 144.49 43.653 143.837 44.4508 143.837C52.9368 143.837 59.8375 136.937 59.8375 128.451C59.8375 127.642 60.4903 127 61.2881 127C62.0859 127 62.7387 127.653 62.7387 128.451C62.7387 136.937 69.6394 143.837 78.1254 143.837C78.9336 143.837 79.576 144.49 79.576 145.288C79.576 146.086 78.9232 146.738 78.1254 146.738C69.6394 146.738 62.7387 153.639 62.7387 162.125C62.7387 162.933 62.0859 163.576 61.2881 163.576ZM51.6002 145.288C55.952 147.143 59.4334 150.634 61.2881 154.976C63.1428 150.624 66.6346 147.143 70.976 145.288C66.6243 143.433 63.1428 139.941 61.2881 135.6C59.4334 139.952 55.9416 143.433 51.6002 145.288Z",
				fill: "#FFE380"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M218.1 363.707C226.24 363.707 232.839 357.107 232.839 348.967C232.839 340.827 226.24 334.228 218.1 334.228C209.959 334.228 203.36 340.827 203.36 348.967C203.36 357.107 209.959 363.707 218.1 363.707Z",
				fill: "#9EC5FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M281.055 363.707C289.195 363.707 295.794 357.107 295.794 348.967C295.794 340.827 289.195 334.228 281.055 334.228C272.915 334.228 266.315 340.827 266.315 348.967C266.315 357.107 272.915 363.707 281.055 363.707Z",
				fill: "#9EC5FF"
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 225,
				y: 63,
				width: 123,
				height: 80,
				rx: 8,
				fill: "#DCEBFE"
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 221,
				y: 58,
				width: 123,
				height: 80,
				rx: 8,
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M237 115L247.753 123.271C248.849 124.114 250.448 123.618 250.875 122.303L255.233 108.867C255.627 107.651 257.044 107.112 258.147 107.758L268.985 114.112C269.852 114.62 270.961 114.406 271.577 113.612L288.339 91.9972C288.99 91.1575 290.184 90.9736 291.058 91.5785L301.101 98.5312C301.907 99.0896 303 98.9805 303.68 98.2736L328 73",
				stroke: "#C2F4F1",
				strokeWidth: 5,
				strokeLinecap: "round"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_22630_1090",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 420,
			height: 415.927,
			fill: "white"
		})
	}) })]
});
export default SvgEmptyStateAnalytics;
